import { render, staticRenderFns } from "./waRefForms.vue?vue&type=template&id=4cb2799c&scoped=true&"
import script from "./waRefForms.vue?vue&type=script&lang=js&"
export * from "./waRefForms.vue?vue&type=script&lang=js&"
import style0 from "./waRefForms.vue?vue&type=style&index=0&id=4cb2799c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb2799c",
  null
  
)

export default component.exports